import type { Namespace } from './types';
export const zh: Namespace = {
  users: {
    title: '用户',
    empty: '没有符合条件的用户',
    roles: {
      9: '用户',
      99: '操作员',
      999: '管理员',
      unknown: '未知角色',
    },
    states: {
      online: '在线',
      offline: '离线',
      enabled: '已启用',
      disabled: '已停用',
    },
    fields: {
      username: '用户名',
      role: '角色',
      email: '邮箱',
      online: '在线',
      enabled: '启用',
      createdAt: '创建时间',
      updatedAt: '更新时间',
    },
    badges: {
      you: '我',
    },
    grants: {
      userManagement: '用户管理（受限：查询 / 核验，仅用户角色）',
      fxQuotes: '汇率报价工具',
    },
    kpi: {
      roles: '角色',
      online: '在线',
      enabled: '启用',
    },
    actions: {
      create: '新增用户',
      createTitle: '新增用户',
      created: '已创建',
      edit: '编辑',
      editTitle: '编辑用户',
      verify: '核验',
      verifyConfirm: '给该用户一次核验配额？',
      verified: '已核验',
      logout: '下线',
      logoutConfirm: '下线 {{count}} 个用户？',
      batchLogout: '批量下线',
      loggedOut: '已下线',
      delete: '删除',
      deleteConfirm: '删除 {{count}} 个用户？',
      batchDelete: '批量删除',
      deleted: '已删除',
      clickToEnable: '点击启用',
      clickToDisable: '点击停用',
      done: '操作已提交',
    },
    modal: {
      username: '用户名',
      password: '密码',
      email: '邮箱',
      role: '角色',
      noSelfEdit: '不能对自己执行此操作',
      current: '当前：',
      keepIfEmpty: '留空表示不修改',
      grants: '授权（仅操作员）',
    },
  },
};

export const en: Namespace = {
  users: {
    title: 'Users',
    empty: 'No users match the filters',
    roles: {
      9: 'User',
      99: 'Operator',
      999: 'Admin',
      unknown: 'Unknown role',
    },
    states: {
      online: 'Online',
      offline: 'Offline',
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    fields: {
      username: 'Username',
      role: 'Role',
      email: 'Email',
      online: 'Online',
      enabled: 'Enabled',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
    },
    badges: {
      you: 'You',
    },
    grants: {
      userManagement: 'User management (restricted: search / verify, USER role only)',
      fxQuotes: 'Fx quotes tool',
    },
    kpi: {
      roles: 'Role',
      online: 'Online',
      enabled: 'Enabled',
    },
    actions: {
      create: 'Add user',
      createTitle: 'Add user',
      created: 'Created',
      edit: 'Edit',
      editTitle: 'Edit user',
      verify: 'Verify',
      verifyConfirm: 'Give this user one verify quota?',
      verified: 'Verified',
      logout: 'Sign out',
      logoutConfirm: 'Sign out {{count}} user(s)?',
      batchLogout: 'Sign out selected',
      loggedOut: 'Signed out',
      delete: 'Delete',
      deleteConfirm: 'Delete {{count}} user(s)?',
      batchDelete: 'Delete selected',
      deleted: 'Deleted',
      clickToEnable: 'Click to enable',
      clickToDisable: 'Click to disable',
      done: 'Submitted',
    },
    modal: {
      username: 'Username',
      password: 'Password',
      email: 'Email',
      role: 'Role',
      noSelfEdit: 'You cannot run this action on yourself',
      current: 'Current: ',
      keepIfEmpty: 'Leave empty to keep unchanged',
      grants: 'Grants (operators only)',
    },
  },
};
